import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=0bf41f66"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"
import style0 from "./WarningMessage.vue?vue&type=style&index=0&id=0bf41f66&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf41f66')) {
      api.createRecord('0bf41f66', component.options)
    } else {
      api.reload('0bf41f66', component.options)
    }
    module.hot.accept("./WarningMessage.vue?vue&type=template&id=0bf41f66", function () {
      api.rerender('0bf41f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/WarningMessage.vue"
export default component.exports